export const version ="version 1.2-4.20";
export const cookieNameVisited = "LandRecordsVisited";

export const landRecordsUrl = "https://coemapservices.encinitasca.gov/hypegis/rest/services/Unsecured/LandRecords_Web_Fabric/MapServer";

export const grayBasemapUrl = "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer";
export const basemapUrl = "https://coemapservices.encinitasca.gov/hypegis/rest/services/Unsecured/BasemapPlus/MapServer";
// export const imageUrl = "https://coemapservices.encinitasca.gov/hypegis/rest/services/Unsecured/Imagery_2017_Web/MapServer";
export const nearMAPURL = "https://api.nearmap.com/wms/v1/places/11d881f5-4e86-4810-a39d-e2837a807d9a/apikey/OTk4ZjUzODYtZDQ3YS00YTAwLWFiNWUtMThkNjQ5NWVlNTY0";
export const locatorUrl = "https://coemapservices.encinitasca.gov/hypegis/rest/services/Unsecured/GISSQL_Address/GeocodeServer";
export const geometryServiceUrl = "https://coemapservices.encinitasca.gov/hypegis/rest/services/Utilities/Geometry/GeometryServer";
export const printServiceUrl = "https://coemapservices.encinitasca.gov/hypegis/rest/services/Unsecured/PrintService/GPServer/Export%20Web%20Map";

// export const PrintLogoSrc = "https://landrecords.encinitasca.gov/images/encinitas-logo-report-sand.jpg";
export const PrintLogoSrc = "https://ezoning.encinitasca.gov/images/encinitas-logo-report-sand.jpg";

export const pointSymbol = {
  type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
  color: [0, 0, 0, 0],
  style: "circle",
  size: 20,
  outline: {  // autocasts as new SimpleLineSymbol()
    color: "#0f0",
    width: 2
  }
};

export const pointsHighlightSymbol = {
  type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
  color: "#ff0",
  style: "circle",
  size: 20,
  outline: {  // autocasts as new SimpleLineSymbol()
    color: "#0f0",
    width: 2
  }
};
